import SDIcon from '../SDIcon'

const IconLineRed = (props) => (
  <SDIcon viewBox='0 0 54 4' {...props}>
    <rect width='54' height='4' rx='2' fill='#C20000' />
  </SDIcon>
)

export default IconLineRed
